import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';
import { mockData } from '../mock';

export const DEFAULT_PRICING = {
  kicker: 'Klar for Refuel?',
  heading: 'Meld deg på no',
  intro: 'Meld deg på for å delta heile helga. Du vel overnatting og éin aktivitet i påmeldingsskjemaet.',
  cards: [
    { id: 'pass', icon: 'ticket', title: 'Festivalpass', price: '200 kr', desc: 'Heile helga – konserten er inkludert. Du kan velje éin aktivitet, og det gjer du i påmeldinga.' },
    { id: 'overnatting', icon: 'bed', title: 'Overnatting', price: '50 kr', desc: 'Pr natt på Øygarden Ungdomsskule. Frokost er inkludert for dei som overnattar.' },
    { id: 'konsert', icon: 'music', title: 'Konsertbillett', price: '200 kr', desc: 'Gjeld berre konserten laurdagskvelden – ikkje resten av helga.' },
  ],
  note: mockData.pricing.note,
  primary: 'Meld deg på',
  secondary: 'Kun konsertbillett',
};

export const DEFAULT_SPEAKERS = mockData.speakers.map((s) => ({
  id: s.id, name: s.name, role: s.role, image: s.image || '', bio: s.bio || [], comingSoon: !!s.comingSoon,
  instagram: s.socials?.find((x) => x.type === 'instagram')?.href || '', photoCredit: s.photoCredit || '',
}));
export const DEFAULT_HOSTS = mockData.hosts.map((h) => ({ id: h.id, name: h.name, role: h.role, image: '', bio: [], comingSoon: true, instagram: '' }));

const ContentContext = createContext({ content: {}, loaded: false, saveContent: async () => {}, saveLoginMethods: async () => {}, uploadImage: async () => '' });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    api.get('/content')
      .then((r) => setContent(r.data || {}))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const saveContent = useCallback(async (key, value) => {
    await api.put(`/admin/content/${key}`, value);
    setContent((c) => ({ ...c, [key]: value }));
  }, []);

  const saveLoginMethods = useCallback(async (methods, hideMethodsPassword = '') => {
    await api.put('/admin/login-methods', { methods, hide_methods_password: hideMethodsPassword });
    setContent((current) => ({
      ...current,
      site: { ...(current.site || {}), loginMethods: methods },
    }));
  }, []);

  const uploadImage = useCallback(async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const { data } = await api.post('/admin/images', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data.path;
  }, []);

  const value = useMemo(() => ({ content, loaded, saveContent, saveLoginMethods, uploadImage }), [content, loaded, saveContent, saveLoginMethods, uploadImage]);
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
